import React from "react";
import styles from "./styles.module.scss";
import { InputSearch } from "../../../../../../boxes/InputSearch/InputSearch";
import { Select } from "../../../../../../shared/Select/Select";
import { useAppTranslation } from "../../../../../../i18n/useAppTranslation";
import { DateRangePicker } from "../../../../../../shared/DateRangePicker/DateRangePicker";
import { useCurrentUserQuery } from "../../../../../../api/queries/useUserQuery";
import { Checkbox } from "../../../../../../shared/Checkbox/Checkbox";

export function Filter({ search, filter, period, docTypes }) {
  var { tClients: t } = useAppTranslation.Clients();
  var { data: user } = useCurrentUserQuery();

  return (
    <div className={styles.root}>
      <div className={styles.left}>
        <InputSearch value={search.value} onChange={search.update} />
        <Select
          size="small"
          placeholder={t("documents.filter.doc_type")}
          options={docTypes}
          className={styles.select}
          value={docTypes.find((x) => x.value === filter.value.type)}
          onChange={(o) =>
            filter.update((prev) => ({ ...prev, type: o.value }))
          }
        />
        <DateRangePicker
          size="small"
          dateFormat={user?.dateFormat}
          onChange={({ startDate, endDate }) => {
            period.update({
              from: startDate,
              to: endDate,
            });
          }}
          value={{
            startDate: period.value.from,
            endDate: period.value.to,
          }}
        />
      </div>
      <Checkbox
        size="small"
        label={t("documents.filter.expiring_soon")}
        isChecked={filter.value.expired}
        onChange={() => {
          filter.update((prev) => ({
            ...prev,
            expired: !prev.expired,
          }));
        }}
      />
    </div>
  );
}
